import { SubmissionErrors } from 'store/declarations/ireland/ireland-notification';
import resolveErrorField from '../resolveErrorField';
import { ErrorCard, ErrorCardContext, ErrorCardField } from '../error-cards/types';
import labelErrorField from '../error-cards/labelErrorField';

/**
 * Every Revenue error is one card. Revenue's own message says more than our translation of it, so it is
 * shown first. An error can name several fields - each is a line of its own, counting from one.
 */
const getAisErrorCards = (
    errors: SubmissionErrors[] | undefined,
    context: ErrorCardContext
): ErrorCard<SubmissionErrors>[] => {
    const toField = (path: string): ErrorCardField => {
        const resolved = resolveErrorField(path, { ...context.fieldContext, firstNumber: 1 });
        return { ...resolved, label: labelErrorField(path, resolved, 1, context) };
    };

    return (errors ?? []).map((error) => ({
        code: error.businessRuleCode ?? error.irelandTranslationTable?.code,
        message: error.externalErrorMessage ?? error.irelandTranslationTable?.message ?? error.message,
        fields: (error.fields ?? []).map(toField),
        related: [],
        error,
    }));
};

export default getAisErrorCards;
